
import React from 'react';
import PropTypes from 'prop-types';

const Input = ({
    label,
    name,
    type = 'text',
    value,
    onChange,
    placeholder,
    className = '',
    style = {},
    ...props
}) => {
    const inputStyles = {
        background: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        color: '#fff',
        padding: '16px',
        borderRadius: '8px',
        width: '100%',
        boxSizing: 'border-box',
        fontSize: '1.1rem',
        transition: 'border-color 0.2s',
        ...style
    };

    return (
        <div className={`form-group ${className}`} style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {label && <label style={{ color: '#fff', fontSize: '0.9rem' }}>{label}</label>}
            <input
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                style={inputStyles}
                onFocus={(e) => {
                    e.target.style.borderColor = '#d90429';
                    e.target.style.outline = 'none';
                }}
                onBlur={(e) => {
                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                }}
                {...props}
            />
        </div>
    );
};

Input.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object
};

export default Input;
